// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e52cc356dec96d1a063e","293":"2adfafc08b992de68c1b","518":"fa8eccb0621b622a2059","779":"94a81a849420bdd3adee"}[chunkId] + ".js";
};